import { Check } from "@phosphor-icons/react"
import { Card } from "@tokenterminal/core/ui/layout/card/Card"
import Image from "next/image"
import { twMerge } from "tailwind-merge"
import { BASE_PATH } from "@/constants/app.mjs"
import Container from "../../common/Container"
import Layout from "../../common/Layout"
import MarketingHeading from "../../common/MarketingHeading"
import ChainPartnerGrid from "./ChainPartnerGrid"
import DataPipelineIllustration from "./DataPipelineIllustration"
import FeaturedCaseStudies from "./FeaturedCaseStudies"

const valueProps = [
  "Token Terminal builds and maintains an end-to-end data pipeline for your chain.",
  "Your team gets full access to all three (3) of Token Terminal's data products.",
  "Your chain's data (and its application ecosystem) is featured across all of Token Terminal's data products & channels (incl. the Bloomberg Terminal).",
  "Your chain's native token becomes eligible for Token Terminal-powered cryptoasset indexes, maintained in collaboration with MarketVector.",
]

// const heroContainerCss = style({
//   position: "absolute",
//   left: 0,
//   top: "-100px",
//   height: "50vh",
//   width: "100vw",
// })

const _heroContainerCss = "absolute left-0 top-[-100px] h-[50vh] w-full"

// const listingTypeCardCss = style([
//   atoms({
//     borderRadius: "5x",
//     padding: ["7x", "12x"],
//   }),
//   {
//     background: "#0d0d0d",
//     border: "none",
//   },
// ])

const _listingTypeCardCss = "rounded-md p-7 md:p-12 bg-[#0d0d0d] border-none"

// const listingTypeBadgeCss = style([
//   atoms({
//     borderRadius: "5x",
//     // paddingX: "4x",
//     // paddingY: "2x",
//     width: "fit-content",
//   }),
//   {
//     // border: `1px solid ${getColor("input.default.border", 0.5)}`,
//     // backgroundColor: getColor("input.default.border", 0.5),
//     backdropFilter: "blur(2px)",
//     selectors: {
//       "&.standardized": {
//         // backgroundColor: "hsla(190, 100%, 12%, 0.5)",
//       },
//     },
//   },
// ])

const _listingTypeBadgeCss = ""

// const listingTypeBadgeTextCss = style([
//   atoms({
//     fontWeight: "600",
//   }),
//   {
//     letterSpacing: "-0.5px",
//   },
// ])

const _listingTypeBadgeTextCss = ""

// const headingCss = style([
//   atoms({
//     fontWeight: "500",
//     textAlign: "center",
//   }),
//   {
//     fontSize: "70px",
//     letterSpacing: "-3px",
//     lineHeight: ".95em",
//     "@media": {
//       [`(max-width: ${breakpoints.tablet}px)`]: {
//         fontSize: "46px",
//       },
//     },
//   },
// ])

// const fadeInAnimation = keyframes({
//   from: {
//     filter: "blur(10px)",
//     opacity: 0,
//   },
//   to: {
//     filter: "blur(0)",
//     opacity: 1,
//   },
// })

const _fadeInCss = ""

// const fadeInCss = style({
//   opacity: 0,
//   filter: "blur(10px)",
//   animation: `${fadeInAnimation} 2s cubic-bezier(.27,.01,0,1)`,
//   animationFillMode: "forwards",
// })

// export const headingCss = style([
//   atoms({
//     fontWeight: "500",
//     textAlign: "center",
//   }),
//   {
//     fontSize: "80px",
//     letterSpacing: "-2.5px",
//     lineHeight: ".95em",
//     "@media": {
//       [`(max-width: ${breakpoints.tablet}px)`]: {
//         fontSize: "46px",
//       },
//     },
//   },
// ])

// export const dataPartnerSectionCss = style({
//   width: "40%",
//   flexShrink: 0,
//   "@media": {
//     [`(max-width: ${breakpoints.tablet}px)`]: {
//       width: "100%",
//     },
//   },
// })

// export const gradientOverlayCss = style({
//   position: "absolute",
//   left: 0,
//   top: 0,
//   height: "100vh",
//   width: "100%",
//   background: `linear-gradient(180deg, rgba(0,0,0,0) 0%, #0d0d0d 100%)`,
// })

// export const dataPipelineSectionCss = style({
//   gap: space["12x"],
//   alignItems: "flex-start",
//   "@media": {
//     [`(max-width: ${breakpoints.desktop}px)`]: {
//       flexDirection: "column",
//       alignItems: "flex-start",
//     },
//   },
// })

// export const illustrationCardCss = style([
//   atoms({
//     borderRadius: "3x",
//   }),
//   {
//     flex: 1,
//     height: "auto",
//     aspectRatio: "16 / 7",
//     background: "rgba(255,255,255,.025)",
//     overflow: "hidden",
//     position: "relative",
//     "@media": {
//       [`(max-width: ${breakpoints.desktop}px)`]: {
//         flex: "none",
//         width: "100%",
//         height: "auto",
//       },
//     },
//   },
// ])
const illustrationCardCss =
  "flex-[none] w-full h-auto lg:flex-1 aspect-[16/7] bg-bg-surface-hover rounded-md overflow-hidden relative"
const _dataPartnerSectionCss = "w-full lg:w-[40%] flex-shrink-0"
const gradientOverlayCss = "absolute inset-0 bg-gradient-to-b from-transparent to-bg-default"
const heroImageCss = "w-full h-full object-cover object-bottom aspect-[2106/772]"
const headingCss = "text-[46px] lg:text-[70px] leading-[0.95em]  text-center"
const dataPipelineSectionCss = ""

const DataPartnershipPage = () => {
  return (
    <Layout className="theme-dark bg-bg-default text-fg-default">
      <div
        className="flex flex-col gap-2 justify-start"
        style={{
          gap: 100,
          position: "relative",
          width: "100%",
          textAlign: "left",
        }}
      >
        <div
          className={twMerge(
            "flex items-start justify-center gap-2 ",
            "absolute left-0 top-[-100px] h-[50vh] w-full overflow-hidden",
          )}
        >
          <Image
            src={`${BASE_PATH}/static/images/marketing/chain-partnership/chain-partnership-hero.webp`}
            alt="Data Partnership Hero"
            width={2106}
            height={772}
            className={[heroImageCss, "animate-fade-in-up"].join(" ")}
          />
          <div className={gradientOverlayCss} />
        </div>
        <Container
          className="flex flex-col gap-8 items-center"
          style={{
            paddingTop: "150px",
            position: "relative",
            zIndex: 2,
            animationDelay: "0.25s",
            width: "100%",
            textAlign: "center",
          }}
        >
          <div className="text-base font-medium text-fg-secondary">Chain Data Partnerships</div>
          <MarketingHeading level={1} className={headingCss}>
            Your ecosystem,
            <br />
            standardized
          </MarketingHeading>
          <div className="text-sm text-fg-secondary max-w-[500px] leading-[1.5em]">
            An end-to-end onchain data analytics offering for L1s, L2s, and appchains. As part of
            the Data Partnership, we run nodes for your chain and make the chain&apos;s data
            available in raw, decoded, and standardized formats across all of our platforms and data
            products.
          </div>
        </Container>
        <Container>
          <ChainPartnerGrid />
        </Container>
        <Container>
          <div className="flex items-start gap-12 mt-16 flex-col md:flex-row">
            <MarketingHeading
              level={3}
              style={{
                fontSize: "40px",
                letterSpacing: "-2px",
                lineHeight: ".85em",

                fontWeight: 500,
              }}
            >
              An end-to-end data analytics solution
            </MarketingHeading>
            <div
              className="flex flex-col gap-5 items-start text-left"
              style={{ maxWidth: "700px" }}
            >
              {valueProps.map((value) => (
                <div key={value} className="flex items-start gap-4">
                  <Check size="20" style={{ flexShrink: 0 }} />
                  <div className="text-sm text-fg-secondary">{value}</div>
                </div>
              ))}
            </div>
          </div>
        </Container>
        <Container style={{ width: "1400px" }}>
          <FeaturedCaseStudies />
        </Container>
        <Container style={{ width: "1400px" }}>
          <div className={twMerge("flex items-center justify-center", dataPipelineSectionCss)}>
            <Card className={illustrationCardCss}>
              <DataPipelineIllustration />
            </Card>
          </div>
        </Container>
        <div className="bg-gradient-to-b from-bg-default to-bg-surface">
          <Container style={{ paddingBottom: "200px" }}>
            <div className="flex flex-col gap-2 mt-16">
              <div className="flex flex-col gap-12" style={{ maxWidth: "700px", margin: "0 auto" }}>
                <MarketingHeading level={2} style={{ maxWidth: "500px" }}>
                  We are your data partner
                </MarketingHeading>
                <div className="flex flex-col gap-16 items-start">
                  {[
                    {
                      icon: Check,
                      heading:
                        "A trusted data partner with a proven track-record of serving onchain data in a reliable and investor-friendly manner.",
                      body: "Launched in 2020, Token Terminal has established itself as a household name in the crypto data analytics market. Most recently, the platform was integrated to the Bloomberg Terminal, as the first crypto data analytics application of its kind. Further, Token Terminal has partnered with MarketVector to maintain fundamentals-weighted cryptoasset indexes.",
                    },
                    {
                      icon: Check,
                      heading:
                        "A platform with a unique distribution outside of the retail-driven crypto community.",
                      body: "Token Terminal is uniquely positioned to help crypto protocols and DAOs attract mindshare among a new and growing stakeholder base: institutional investors. Since these investors often manage outside capital, having access to high-quality and standardized data becomes paramount.",
                    },
                    {
                      icon: Check,
                      heading: "A data partner with technical expertise and a long-term mindset.",
                      body: "At Token Terminal, we want to partner with protocol teams for the long-term. In practice, we want to invest in running our own nodes for the relevant chain(s), which allows us to build both scalable and reliable data extraction pipelines. Further, we invest considerable time and resources to data standardization in order to be able to deliver accurate onchain data analytics at the most granular level possible.",
                    },
                  ].map((section) => (
                    <div key={section.heading} className="flex flex-col gap-3 width-full">
                      <div className="text-base font-medium text-fg-default">{section.heading}</div>
                      <div className="text-base text-fg-secondary">{section.body}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </Layout>
  )
}

export default DataPartnershipPage
